// extracted by css-extract-rspack-plugin
export default {"ActionMenu_Overlay":"field-sum-menu-module__ActionMenu_Overlay__WdlkDwD"};